import { createSelector } from 'reselect';
import { Map } from 'immutable';

import { State } from 'reducers';
import Budget from 'entities/budget/model';

const sortFunction = (a: Budget, b: Budget): number =>
  (+a.startingAt || +a.createdAt) - (+b.startingAt || +b.createdAt);

const selectBudgetState = (state: State): Map<string, Budget> => state.get('entities').budget;

export const selectBudgets = createSelector(selectBudgetState, (budgets) =>
  budgets.sort(sortFunction)
);

export const selectBudgetById = createSelector(
  selectBudgetState,
  (_budgets, budgetId) => budgetId,
  (budgets, budgetId) => budgets.get(budgetId)
);
